export default "__VITE_ASSET__CU0PZON4__"